import { render, staticRenderFns } from "./phone_order.vue?vue&type=template&id=47189c21&scoped=true&"
import script from "./phone_order.vue?vue&type=script&lang=js&"
export * from "./phone_order.vue?vue&type=script&lang=js&"
import style0 from "./phone_order.vue?vue&type=style&index=0&id=47189c21&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47189c21",
  null
  
)

export default component.exports